// @vendor
const moment = require('moment');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const {
    MONTHLY__FETCHING,
    MONTHLY__SUCCESS,
    MONTHLY__FAILURE,
    MONTHLY__TOTALIZED__FETCHING,
    MONTHLY__TOTALIZED__SUCCESS,
    MONTHLY__TOTALIZED__FAILURE
} = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');
const { ALL_CATEGORIES } = require('constants/expensesByCategories/filters');


const requestMonthlyFetching = () => {
    return {
        type: MONTHLY__FETCHING
    };
}

const requestMonthlySuccess = (response) => {
    return {
        type: MONTHLY__SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestMonthlyFailure = () => {
    return {
        type: MONTHLY__FAILURE,
    };
}

const requestMonthlyTotalizedExpenseFetching = () => {
    return {
        type: MONTHLY__TOTALIZED__FETCHING
    };
}

const requestMonthlyTotalizedExpenseSuccess = (response) => {
    return {
        type: MONTHLY__TOTALIZED__SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestMonthlyTotalizedExpenseFailure = () => {
    return {
        type: MONTHLY__TOTALIZED__FAILURE,
    };
}

const requestMonthlyTotalizedExpense = filters => dispatch => {
    const requestData = {
        header: {
            version: 2
        },
        query: {
            temporalGrouping: 'M',
            contracts: filters.contracts,
            from: moment().startOf('month').format(DATE_FORMAT_API),
            to: moment().format(DATE_FORMAT_API),
            categoryCode: [ALL_CATEGORIES],
            banks: filters.banks,
        }
    };

    dispatch(requestMonthlyTotalizedExpenseFetching());

    APIPost(dispatch, apiURLBuilder.getURL('globalExpensesTotalsAll'), requestData)
    .then( response => dispatch(requestMonthlyTotalizedExpenseSuccess(response.total)))
    .catch(() => dispatch(requestMonthlyTotalizedExpenseFailure()));
}

const requestMonthly = filters => (dispatch) => {

    const requestData = {
        query: {
            "to": `${moment().format(DATE_FORMAT_API)}`,
            banks: filters.banks
        }
    };

    dispatch(requestMonthlyFetching());

    APIPost(dispatch, apiURLBuilder.getURL('globalMontlhyExpenses'), requestData)
    .then((response) => {
            dispatch(requestMonthlyTotalizedExpense(filters))
            dispatch(requestMonthlySuccess(response))
        }
    )
    .catch(error => dispatch(requestMonthlyFailure(error)));
}

module.exports = {
    requestMonthly,
    requestMonthlyTotalizedExpense
}
